import p from './order-distribute-no-manage.vue';

export default p;
